import React from 'react'
import { Link } from 'react-router-dom'
import Furnitur_1 from '../../../assets/images/furniture/01.png'
import Furnitur_2 from '../../../assets/images/furniture/02.png'
import Furnitur_3 from '../../../assets/images/furniture/03.png'
import Furnitur_4 from '../../../assets/images/furniture/04.png'
import Furnitur_5 from '../../../assets/images/furniture/05.png'

const Furnitur = () => {

    return (
        <>
            <section id="furniture" className="furniture-main-block">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-4 col-lg-12">
                            <div className="furniture-block">
                                <div className="furniture-dtl">
                                    <ul>
                                        <li>
                                            <span>#Featured</span>
                                        </li>
                                        <li>
                                            <h3 className="featured-title">
                                                <Link to="/Shop" title="">
                                                    Atlasian Chair
                                                </Link>
                                            </h3>
                                        </li>
                                        <li>
                                            <Link to="/Shop" className="btn btn-info" title="">
                                                Shop Now
                                                <i className="flaticon-right-arrows" />
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="furniture-img furniture-img-one">
                                    <Link to="/Shop" title="">
                                        <img
                                            src={Furnitur_1}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-8 col-lg-12">
                            <div className="row">
                                <div className="col-lg-4 col-md-4">
                                    <div className="furniture-block furniture-block-two">
                                        <div className="furniture-dtl">
                                            <ul>
                                                <li>
                                                    <span>#Exclussive</span>
                                                </li>
                                                <li>
                                                    <h3 className="featured-title">
                                                        <Link to="/Shop" title="">
                                                            Wood Lighting
                                                        </Link>
                                                    </h3>
                                                </li>
                                                <li>
                                                    <Link to="/Shop" className="btn btn-info" title="">
                                                        Shop Now
                                                        <i className="flaticon-right-arrows" />
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="furniture-img">
                                            <Link to="/Shop" title="">
                                                <img
                                                    src={Furnitur_2}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8 col-md-8">
                                    <div className="furniture-block furniture-block-two furniture-block-three">
                                        <div className="row">
                                            <div className="col-lg-8 col-md-7">
                                                <div className="furniture-img">
                                                    <Link to="/Shop" title="">
                                                        <img
                                                            src={Furnitur_3}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-5">
                                                <div className="furniture-dtl">
                                                    <ul>
                                                        <li>
                                                            <span>#Trending Now</span>
                                                        </li>
                                                        <li>
                                                            <h3 className="featured-title">
                                                                <Link to="/Shop" title="">
                                                                    Smart Wall Desk
                                                                </Link>
                                                            </h3>
                                                        </li>
                                                        <li>
                                                            <Link to="/Shop" className="btn btn-info" title="">
                                                                Shop Now
                                                                <i className="flaticon-right-arrows" />
                                                            </Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-8 col-md-8">
                                    <div className="furniture-block furniture-block-two furniture-block-three">
                                        <div className="row">
                                            <div className="col-lg-8 col-md-7">
                                                <div className="furniture-img">
                                                    <Link to="/Shop" title="">
                                                        <img
                                                            src={Furnitur_4}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-5">
                                                <div className="furniture-dtl">
                                                    <ul>
                                                        <li>
                                                            <span>#Most Popular</span>
                                                        </li>
                                                        <li>
                                                            <h3 className="featured-title">
                                                                <Link to="/Shop" title="">
                                                                    Officially Sofa
                                                                </Link>
                                                            </h3>
                                                        </li>
                                                        <li>
                                                            <Link to="/Shop" className="btn btn-info" title="">
                                                                Shop Now
                                                                <i className="flaticon-right-arrows" />
                                                            </Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                    <div className="furniture-block furniture-block-two">
                                        <div className="furniture-dtl">
                                            <ul>
                                                <li>
                                                    <span>#New Arrivals</span>
                                                </li>
                                                <li>
                                                    <h3 className="featured-title">
                                                        <Link to="/Shop" title="">
                                                            Office Desk
                                                        </Link>
                                                    </h3>
                                                </li>
                                                <li>
                                                    <Link to="/Shop" className="btn btn-info" title="">
                                                        Shop Now
                                                        <i className="flaticon-right-arrows" />
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="furniture-img">
                                            <Link to="/Shop" title="">
                                                <img
                                                    src={Furnitur_5}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Furnitur
